import { Typography } from "@mui/material"
import { styled, TypographyProps } from "@mui/system"

const FeelingDetailsHeader = styled(Typography)<TypographyProps>(() => ({
  fontFamily: "SofiaProMedium",
  fontSize: "28px",
}))

export default FeelingDetailsHeader
